export enum CommonLiterals {
  SAVE = "Save",
  CANCEL = "Cancel",
  LOADING = "Loading...",
  NO_DATA = "No data available",
  NO_PDF_AVAILABLE = "No PDF available",
  NO_SCREENSHOT_AVAILABLE = "No Screenshot available",
  LOADING_FINAL_SCREENSHOT = "Loading final screenshot...",
  RE_RUN_MODAL_TEXT = "Are you sure you want to rerun the SFTP for this order ?",
  NO_DENIAL_LETTER_AVAILABLE = "No Denial Letter available",
  LOADING_DENIAL_LETTER = "Loading denial letter...",
}
